import React, { useContext } from 'react';
// eslint-disable-next-line import/no-cycle
import Row from '../common/Row';
// eslint-disable-next-line import/no-cycle
import { TableContext } from '../../CustomTable';

export default function HeadRow({ children }) {
  const ctx = useContext(TableContext);

  return (
    <div>
      <Row withLines={ctx.withLines?.header}>{children}</Row>
    </div>
  );
}
